import './grossTareWeight.css';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { authKey, PERMISSIBLE_DEVIATION_CONFIG, GET_CONSIGNMENT_NO_TOKEN_NO_BY_URN, GET_LLE_GROSS_TARE_MEASUREMENT} from '../../../common/URLs';

import jwt from 'jwt-decode';
// import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
// import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
// import { confirmAlert } from 'react-confirm-alert';
// import { loaderService } from "../../common/custom-loader/loader-service";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import apiClient from '../../../axios';


function GrossTareWeight() {

    const navigate = useNavigate();
    const [permissibleDeviation, setPermissibleDeviation] = useState();
    const [listConsignmetTokenNo, setListConsignmetTokenNo] = useState();
    const [getGrossTareWeightMeasurement, setGetGrossTareWeightMeasurement] = useState();
    const [selectedConsignment, setSelectedConsignment] = useState();
    const [selectedToken, setSelectedToken] = useState();

    // const [stakeholderType,setStakeholderType] = useState();
    // const [urn, setUrn] = useState();

    useEffect(() => {

        getPermissibleDeviationConfig()
       
     }, []);


   const getPermissibleDeviationConfig = () => {
       apiClient
         .post(PERMISSIBLE_DEVIATION_CONFIG , 
               {

                },
              {
                   headers: 
                   {
                   Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                             }
               }, null
         )
         .then((response) => {
           
            setPermissibleDeviation(response.data.pitConfigurations[0]);
                        
         })
         .catch(function (error) {
           console.log(error);
         });
     }

    //  useEffect(() => {
    //     if (getLocalStorageItem('id_token')) {
    //       const decoded = jwt(getLocalStorageItem('id_token'));
    //       if (decoded.extension_URN) {
    //         setUrn(decoded.extension_URN)
    //       }
    
    //     }
    //   }, [getLocalStorageItem('id_token')]);
    
      useEffect(() => {
    
        getConsignmentTokenNo();
    
      }, []);
    
    
      const getConsignmentTokenNo = () => {
        apiClient
          .post(GET_CONSIGNMENT_NO_TOKEN_NO_BY_URN,
            {
                "consignmentSourceType": "lle",
                "consignmentSourceUrn": "URN-LLELL00302"
            },
            {
              headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
              }
            }, null
          )
          .then((response) => {

            setListConsignmetTokenNo(response.data.consignmentNoList);     
            //setGetTokenNo(response.data.consignmentNoList[0].tokenNo);    
            console.log(response.data.consignmentNoList)   
          })
          .catch(function (error) {
            console.log(error);
          });
      }

      useEffect(() => {

        getLleGrossTareWeight();
       
     }, []);


   const getLleGrossTareWeight = () => {
       apiClient
         .post(GET_LLE_GROSS_TARE_MEASUREMENT , 
               {
                "consignmentNo": "CON-00002"

                },
              {
                   headers: 
                   {
                   Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                             }
               }, null
         )
         .then((response) => {
           
            setGetGrossTareWeightMeasurement(response.data);  
            //console.log("getting",getGrossTareWeightMeasurement)     
                        
         })
         .catch(function (error) {
           console.log(error);
         });
     }

     const onChangeConsignmentOrToken = (e) => {
      e.preventDefault();
      const getconsNo = e.target.value;
      setSelectedConsignment(getconsNo);
      const gettokenNo = e.target.value;
      setSelectedToken(gettokenNo);
    }

    return (
        <div>
            <Container fluid>
                <Row>
                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                        <div className="common-internal-sidebar-container">
                            <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/dashboardStakeHolder'))} />
                        </div>
                    </Col> */}

                    <Col xs={12} md={12}>
                        <div>
                        {!PROD &&    <p style={{textAlign:"center", fontSize:"2vh"}}>PIT39</p> }
                            <form>
                            
                            <Container fluid>
                                <Row>
                                <div className="view-gross-weight-txt">LLE Gross & Tare weight measurement</div>
                                    <Col xs={12} md={10}>
                                    <div className='permissible-deviation-div'>
                                    <p className='labels-gross-weight'>Permissible deviation of the RB weight: </p>
                                    <input className='input-field-permissible-gross-weight' type="text" placeholder='Permissible deviation of the RB weight' disabled={true} value={permissibleDeviation?.value}></input>
                                    </div>
                                    <p className='labels-gross-weight'>Choose Consignment/Token </p>
                                    <select className='input-field-gross-weight-ConsToks' onChange={(e) => onChangeConsignmentOrToken(e)}>
                                    <option>--Select--</option>
                                        <option value="consNo">Consignment No</option>
                                        <option value="tokNo">Token No</option>
                                        {/* {listConsignmetTokenNo && listConsignmetTokenNo.map((item) => (
                                                    <option value={item.id}>{item.consignmentNo}</option>
                                        ))} */}
                                         
                                    </select>
                                    <p className='labels-gross-weight'>List of Consignment/Token</p>
                                    <select className='input-field-gross-weight-ConsToks'>
                                        <option>--Select--</option>
                                        {/* {listConsignmetTokenNo && listConsignmetTokenNo.map((item) => (
                                                    <option value={item.id}>{item.tokenNo}</option>
                                        ))} */}
                                    </select>
                                    <p className='details-labels-gross-weight'>Please find the below details</p>
                                    
                                    </Col>
                                    {/* <Col xs={12} md={4}>
                                      
                                    
                                    </Col>
                                    <Col xs={12} md={4}>
                                    
                                    </Col> */}
                                   
                                </Row>
                            </Container> 
                            
                                <Container fluid>
                                <Row>
                                    <Col xs={12} md={4}>
                                    
                                    <p className='labels-gross-weight'>Token</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Token' disabled={true} value={getGrossTareWeightMeasurement?.tokenNo} ></input>
                                    <p className='labels-gross-weight'>Consignment </p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Consignment ' disabled={true} value={getGrossTareWeightMeasurement?.consignmentNo}></input>
                                    <p className='labels-gross-weight'>Grower PO</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Grower PO' disabled={true} value={getGrossTareWeightMeasurement?.growerPOList}></input>
                                    <p className='labels-gross-weight'>Vehicle No.</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Vehicle No.' disabled={true} value={getGrossTareWeightMeasurement?.vehicleRegNo}></input>
                                    {/* <p className='labels-gross-weight'>Driver Name</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Driver Name' disabled={true} value={getGrossTareWeightMeasurement?.driverName}></input>
                                    <p className='labels-gross-weight'>Weight during pickup</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Weight during pickup' disabled={true} value={getGrossTareWeightMeasurement?.pickupWeight}></input> */}
                                    </Col>
                                    <Col xs={12} md={4}>
                                    <p className='labels-gross-weight'>Driver Name</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Driver Name' disabled={true} value={getGrossTareWeightMeasurement?.driverName}></input>
                                    <p className='labels-gross-weight'>Weight during pickup</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Weight during pickup' disabled={true} value={getGrossTareWeightMeasurement?.pickupWeight}></input>
                                    <p className='labels-gross-weight'>Average Moisture during the pickup</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Average Moisture during the pickup' disabled={true} value={getGrossTareWeightMeasurement?.pickupMoisture}></input>
                                    <p className='labels-gross-weight'>Gross weight measured @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" onFocus={handleNumberFieldFocus} placeholder='Gross weight measured @ LLE'></input>
                                    {/* <p className='labels-gross-weight'>Average Moisture during the pickup</p>
                                    <input className='input-field-gross-weight' type="text" placeholder='Average Moisture during the pickup' disabled={true} value={getGrossTareWeightMeasurement?.pickupMoisture}></input>
                                    <p className='labels-gross-weight'>Gross weight measured @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" placeholder='Gross weight measured @ LLE'></input>
                                    <p className='labels-gross-weight'>Tare weight measured @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" placeholder='Tare weight measured @ LLE'></input>
                                    <p className='labels-gross-weight'>Net RB weight as per measurement</p>
                                    <input className='input-field-gross-weight' type="number" placeholder='Net RB weight as per measurement'></input>
                                    <p className='labels-gross-weight'>Average Moisture @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" placeholder='Average Moisture @ LLE'></input> */}
                                    </Col>
                                    <Col xs={12} md={4}>
                                    <p className='labels-gross-weight'>Tare weight measured @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" onFocus={handleNumberFieldFocus} placeholder='Tare weight measured @ LLE'></input>
                                    <p className='labels-gross-weight'>Net RB weight as per measurement</p>
                                    <input className='input-field-gross-weight' type="number" onFocus={handleNumberFieldFocus} placeholder='Net RB weight as per measurement'></input>
                                    <p className='labels-gross-weight'>Average Moisture @ LLE</p>
                                    <input className='input-field-gross-weight' type="number" onFocus={handleNumberFieldFocus} placeholder='Average Moisture @ LLE'></input>
                                    
                                    </Col>
                                     <Col xs={12} md={2}>
                                    <div className='submit-div-labels-gross-weight'>
                                     <button className='submit-btn-labels-gross-weight' type='submit' >Submit</button>
                                    </div>
                                    </Col>
                                </Row>
                            </Container>
                            
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
export default GrossTareWeight;
